import React, { Component } from "react";

import { getSystemSettings } from "../../utils/SettingsRetriever";
import Dialog from "../Dialog";
import Button from '@material-ui/core/Button';

export default class RequiredPopup extends Component{
  state = {
    requiredModal: false
  }
  requiredPopupSettings = getSystemSettings().requiredPopup;

  componentDidMount() {
    const currentUrl = window.location.pathname;
    if (this.requiredPopupSettings && this.requiredPopupSettings.enabled && ( (!this.requiredPopupSettings.section && currentUrl === "/checkout/review") || (currentUrl.indexOf(this.requiredPopupSettings.section) >= 0))) {
      this.setState({ requiredModal: true });
    }
  }
  
  render() {
    return (
      <Dialog
        title={this.requiredPopupSettings && this.requiredPopupSettings.title}
        open={this.state.requiredModal}
        className="requiredModal"
        size="md"
        footerContent={
            <React.Fragment>
                <Button onClick={()=>this.setState({ requiredModal: false })} className="secondary">
                    {this.requiredPopupSettings && this.requiredPopupSettings.accept}
                </Button>
            </React.Fragment>
        }
    >
        <div dangerouslySetInnerHTML={{__html: this.requiredPopupSettings && this.requiredPopupSettings.content }} className="body" />
    </Dialog>
    )
  }
}